import { Route } from 'react-router-dom'
import { auth } from '../../../services/util/auth.service'
import React from 'react'
import { EstoqueContextProvider } from '../../../contexts/EstoqueContext'
import EstoqueMenu from './EstoqueMenu/EstoqueMenu'
import CadastroEstoque from './CadastroEstoque/CadastroEstoque'
import CadastroOperacaoEstoque from './CadastroOperacaoEstoque/CadastroOperacaoEstoque'
import MovimentacaoEstoqueRecebimento from './MovimentacaoEstoque/MovimentacaoEstoqueRecebimento/MovimentacaoEstoqueRecebimento'
import CadastroPosicoesEstoque from './CadastroEstoque/CadastroPosicoesEstoque/CadastroPosicoesEstoque'
import MovimentacaoEstoqueTransferencia from './MovimentacaoEstoque/MovimentacaoEstoqueTransferencia/MovimentacaoEstoqueTransferencia'
import MovimentacaoEstoqueExpedicao from './MovimentacaoEstoque/MovimentacaoEstoqueExpedicao/MovimentacaoEstoqueExpedicao'
import ImportacaoExpedicaoXml from './MovimentacaoEstoque/MovimentacaoEstoqueExpedicao/ImportacaoExpedicaoXml/ImportacaoExpedicaoXml'
import MovimentacaoEstoqueExpedicaoExpedir from './MovimentacaoEstoque/MovimentacaoEstoqueExpedicao/MovimentacaoEstoqueExpedicaoExpedir/MovimentacaoEstoqueExpedicaoExpedir'
import MovimentacaoEstoqueAvulso from './MovimentacaoEstoque/MovimentacaoEstoqueAvulso/MovimentacaoEstoqueAvulso'
import VerEstoque from './VerEstoque/VerEstoque'
import RelatorioEstadia from './RelatorioEstadia/RelatorioEstadia'
import Inventario from './Inventario/Inventario'
import AssociarPosicoes from './Inventario/AssociarPosicoes/AssociarPosicoes'
import PosicoesAssociadas from './Inventario/PosicoesAssociadas/PosicoesAssociadas'
import AnaliseResultado from './Inventario/PosicoesAssociadas/AnaliseResultado/AnaliseResultado'
import ImportacaoExpedicaoExcel from './MovimentacaoEstoque/MovimentacaoEstoqueExpedicao/ImportacaoExpedicaoExcel/ImportacaoExpedicaoExcel'
import MovimentacaoPorTipoOperacao from './MovimentacaoPorTipoOperacao/MovimentacaoPorTipoOperacao'
import MovimentacaoPorPosicaoEstoque from './MovimentacaoPorPosicaoEstoque/MovimentacaoPorPosicaoEstoque'
import RelatorioInventarioPosicao from './RelatorioInventarioPosicao/RelatorioInventarioPosicao'
import RelatorioRecallProduto from './RelatorioRecallProduto/RelatorioRecallProduto'
import GerenciamentoPosicoesEstoque from './GerenciamentoPosicoesEstoque/GerenciamentoPosicoesEstoque'
import CadastroMotivoBloqueioPosicaoEstoque from './CadastroMotivoBloqueioPosicaoEstoque/CadastroMotivoBloqueioPosicaoEstoque'
import RelatorioSaldoEstoque from './RelatorioSaldoEstoque/RelatorioSaldoEstoque'
import RelatorioEtiquetasInternadas from './RelatorioEtiquetasInternadas/RelatorioEtiquetasInternadas'
import RelatorioPosicaoDiaria from './RelatorioPosicaoDiaria/RelatorioPosicaoDiaria'
import ExtratoMovimentacaoPorProduto from './ExtratoMovimentacaoPorProduto/ExtratoMovimentacaoPorProduto'
import CadastroOcPrevista from './OrdemCarregamentoPrevista/CadastroOcPrevista'
import CadastroStatusEtiquetaEstoque from './CadastroStatusEtiquetaEstoque/CadastroStatusEtiquetaEstoque'
import ItensManualExpedicao from './MovimentacaoEstoque/MovimentacaoEstoqueExpedicao/ItensManualExpedicao/ItensManualExpedicao'
import HistoricoConferenciaExpedicao from './MovimentacaoEstoque/MovimentacaoEstoqueExpedicao/HistoricoConferenciaExpedicao/HistoricoConferenciaExpedicao'
import RelatorioEstoquePorProduto from './RelatorioEstoquePorProduto/RelatorioEstoquePorProduto'
import RelatorioPosicoesEtiquetasCliente from './RelatorioPosicoesEtiquetasCliente/RelatorioPosicoesEtiquetasCliente'
import ComparativoEntradaAvulsoPicking from './ComparativoEntradaAvulsoPicking/ComparativoEntradaAvulsoPicking'

export default function Estoque() {
  return (
    <EstoqueContextProvider>
      <Route path="/main/estoque/menu" render={() => auth(<EstoqueMenu />)} />
      <Route path="/main/estoque/cadastro-estoque" render={() => auth(<CadastroEstoque />, 110)} />
      <Route
        path="/main/estoque/cadastro-posicoes-estoque"
        render={() => auth(<CadastroPosicoesEstoque />, 110)}
      />
      <Route
        path="/main/estoque/cadastro-operacao-estoque"
        render={() => auth(<CadastroOperacaoEstoque />, 111)}
      />
      <Route
        path="/main/estoque/movimentacao-estoque-recebimento"
        render={() => auth(<MovimentacaoEstoqueRecebimento />, 112)}
      />
      <Route
        path="/main/estoque/movimentacao-estoque-transferencia"
        render={() => auth(<MovimentacaoEstoqueTransferencia />, 113)}
      />
      <Route
        path="/main/estoque/movimentacao-estoque-expedicao"
        render={() => auth(<MovimentacaoEstoqueExpedicao />, 114)}
      />
      <Route
        path="/main/estoque/movimentacao-estoque-expedicao-importacao-xml"
        render={() => auth(<ImportacaoExpedicaoXml />, 114)}
      />
      <Route
        path="/main/estoque/movimentacao-estoque-expedicao-importacao-excel"
        render={() => auth(<ImportacaoExpedicaoExcel />, 114)}
      />
      <Route
        path="/main/estoque/movimentacao-estoque-expedicao-itens-manual"
        render={() => auth(<ItensManualExpedicao />, 114)}
      />
      <Route
        path="/main/estoque/movimentacao-estoque-expedicao-historico"
        render={() => auth(<HistoricoConferenciaExpedicao />, 114)}
      />

      <Route
        path="/main/estoque/movimentacao-estoque-expedicao-expedir"
        render={() => auth(<MovimentacaoEstoqueExpedicaoExpedir />, 114)}
      />
      <Route
        path="/main/estoque/movimentacao-estoque-avulso"
        render={() => auth(<MovimentacaoEstoqueAvulso />, 44)}
      />
      <Route path="/main/estoque/ver-estoque" render={() => auth(<VerEstoque />, 115)} />
      <Route
        path="/main/estoque/relatorio-estadia"
        render={() => auth(<RelatorioEstadia />, 116)}
      />
      <Route path="/main/estoque/inventario" render={() => auth(<Inventario />, 117)} />
      <Route
        path="/main/estoque/inventario-assoc-posicoes"
        render={() => auth(<AssociarPosicoes />, 117)}
      />
      <Route
        path="/main/estoque/inventario-posicoes-assoc"
        render={() => auth(<PosicoesAssociadas />, 117)}
      />
      <Route
        path="/main/estoque/inventario-analise-resultado"
        render={() => auth(<AnaliseResultado />, 117)}
      />
      <Route
        path="/main/estoque/movimentacao-por-tipo-operacao"
        render={() => auth(<MovimentacaoPorTipoOperacao />, 118)}
      />
      <Route
        path="/main/estoque/extrato-movimentacao-por-posicao"
        render={() => auth(<MovimentacaoPorPosicaoEstoque />, 119)}
      />
      <Route
        path="/main/estoque/relatorio-inventario-posicao"
        render={() => auth(<RelatorioInventarioPosicao />, 120)}
      />
      <Route
        path="/main/estoque/relatorio-recall-produto"
        render={() => auth(<RelatorioRecallProduto />, 121)}
      />
      <Route
        path="/main/estoque/gerenciamento-posicoes-estoque"
        render={() => auth(<GerenciamentoPosicoesEstoque />, 122)}
      />
      <Route
        path="/main/estoque/motivo-bloqueio-posicao-estoque"
        render={() => auth(<CadastroMotivoBloqueioPosicaoEstoque />, 123)}
      />
      <Route
        path="/main/estoque/relatorio-saldo-estoque"
        render={() => auth(<RelatorioSaldoEstoque />, 124)}
      />
      <Route
        path="/main/estoque/relatorio-etiquetas-internadas"
        render={() => auth(<RelatorioEtiquetasInternadas />, 125)}
      />
      <Route
        path="/main/estoque/relatorio-posicoes-estoque-diaria"
        render={() => auth(<RelatorioPosicaoDiaria />, 126)}
      />
      <Route
        path="/main/estoque/extrato-movimentacao-por-produto"
        render={() => auth(<ExtratoMovimentacaoPorProduto />, 127)}
      />
      <Route
        path="/main/estoque/ordem-carregamento-prevista"
        render={() => auth(<CadastroOcPrevista />, 128)}
      />
      <Route
        path="/main/estoque/cadastro-status-etiqueta-estoque"
        render={() => auth(<CadastroStatusEtiquetaEstoque />, 129)}
      />
      <Route
        path="/main/estoque/relatorio-estoque-por-produto"
        render={() => auth(<RelatorioEstoquePorProduto />, 136)}
      />
      <Route
        path="/main/estoque/relatorio-posicoes-etiquetas-cliente"
        render={() => auth(<RelatorioPosicoesEtiquetasCliente />, 141)}
      />
      <Route
        path="/main/estoque/comparativo-entrada-avulso-picking"
        render={() => auth(<ComparativoEntradaAvulsoPicking />, 142)}
      />
    </EstoqueContextProvider>
  )
}
